<div class="main-page container">
  <fc-bread-crumb-navigation [navigationString]="'Manage Info / Programs / Program'"></fc-bread-crumb-navigation>
  <h1>{{ programForm.value.id ? 'Edit' : 'Add a New' }} Program</h1>
  <div class="main-panel">
    <fc-spinner
      [show]="this.program === null && this.id"
      [zIndex]="999"
      name="program-spinner"
      text="Loading Program"></fc-spinner>
    <div class="error-message">{{ error }}</div>
    <form [formGroup]="programForm" fcFormUnloadWarning>
      <input formControlName="id" type="hidden" />
      <div class="form-container">
        <div class="fields">
          <mat-form-field class="w-100-1">
            <mat-label>Program Name</mat-label>
            <input formControlName="name" id="name" matInput type="text" />
          </mat-form-field>

          <mat-radio-group class="show-hide" formControlName="isActive" id="isActive">
            <mat-radio-button [value]="true">Active</mat-radio-button>
            <mat-radio-button [value]="false">Inactive</mat-radio-button>
          </mat-radio-group>

          <mat-form-field class="w-100-1">
            <mat-label>Program Type</mat-label>
            <mat-select
              (selectionChange)="changeType($event)"
              class="select-filter"
              formControlName="isNational"
              id="isNational">
              <mat-option value="regional">Regional</mat-option>
              <mat-option value="national">National</mat-option>
            </mat-select>
          </mat-form-field>

          <ng-container *ngIf="programForm.value.isNational === 'regional'">
            <div class="regions">
              <mat-form-field class="w-100-1">
                <mat-label>Regions</mat-label>
                <mat-select class="select-filter" formControlName="regions" id="regions" multiple>
                  <mat-option *ngFor="let region of regionList" [value]="region.id">
                    {{ region.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-chip-listbox>
                <mat-chip-option
                  (removed)="removeRegion($event)"
                  *ngFor="let region of regionSelection"
                  [removable]="true"
                  [selectable]="true">
                  {{ region }}
                  <mat-icon matChipRemove>
                    <fa-icon [icon]="['far', 'xmark']" class="white"></fa-icon>
                  </mat-icon>
                </mat-chip-option>
              </mat-chip-listbox>
            </div>
          </ng-container>

          <mat-form-field class="w-100-1">
            <mat-label>Severity Level</mat-label>
            <mat-select class="select-filter" formControlName="restrictionLevel" placeholder="Filter">
              <mat-option [value]="-1">
                <fa-icon [icon]="['fas', 'question']" [ngStyle]="{ 'vertical-align': 'middle' }" class="blue"></fa-icon>
                <span [ngStyle]="{ 'margin-left': '10px' }">None</span>
              </mat-option>
              <mat-option [value]="0">
                <fa-icon [icon]="['fas', 'circle']" [ngStyle]="{ 'vertical-align': 'middle' }" class="green"></fa-icon>
                <span [ngStyle]="{ 'margin-left': '10px' }">Low</span>
              </mat-option>
              <mat-option [value]="1">
                <fa-icon
                  [icon]="['fas', 'triangle']"
                  [ngStyle]="{ 'vertical-align': 'middle' }"
                  class="yellow"></fa-icon>
                <span [ngStyle]="{ 'margin-left': '10px' }">Medium</span>
              </mat-option>
              <mat-option [value]="2">
                <fa-icon [icon]="['fas', 'octagon']" [ngStyle]="{ 'vertical-align': 'middle' }" class="red"></fa-icon>
                <span [ngStyle]="{ 'margin-left': '10px' }">High</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-divider>&nbsp;</mat-divider>
        <button
          (click)="onSubmit()"
          [disabled]="programForm.invalid"
          class="button"
          color="primary"
          data-cy="submitButton"
          mat-raised-button>
          {{ !programForm.value.id ? 'Create' : 'Update' }} Program
        </button>
      </div>
    </form>
  </div>
</div>
